module.exports = __webpack_public_path__ + "0cb67300419423131df197bf7de9e2e5.jpg";